// constants.js

export const objectiveData = [
  { id: '1', text: 'WebsiteTraffic' },
  { id: '2', text: 'Branding & Reach' },
  { id: '3', text: 'Conversions / Lead Generation' },
]

export const businessTypeData = [
  { id: '1', text: 'Business1' },
  { id: '2', text: 'Business2' },
  { id: '3', text: 'Business3' },
]

export const formFields = {

  campaignName: {
    key: 'campaignName',
    type: 'text',
    label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    pattern: /^(?=.*?[A-Za-z]).{1,}$/,
    maxLength: 80,
    maxLengthMessage: 'maximum 80 characters allowed.',
    spaceNotAllowed: true,
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },

  brandName: {
    key: 'brandName',
    type: 'text',
    label: 'Brand Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Brand Name </div>',
    pattern: /^(?=.*?[A-Za-z]).{1,}$/,
    maxLength: 80,
    maxLengthMessage: 'maximum 80 characters allowed.',
    spaceNotAllowed: true,
  },

  goal: {
    key: 'goal',
    label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  goalValue: {
    key: 'goalValue',
    type: 'number',
    label: 'Goal Value',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    min: 0,
    max:99999,
    upto2Digit: true,
    // minLengthMessage: 'Minimum 3 charactors allowed.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    // labelLayout:'py-1',
    tooltip: '<div> IO Name </div>',
    // spaceNotAllowed: true,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Goal Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
    // pattern: /^(?=.*?[A-Za-z]).{1,}$/
  },
  
  startDate: {
    key: 'startDate',
    label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },


  businessType: {
    key: 'businessType',
    label: 'Business Type',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  brandUrl: {
    key: 'brandUrl',
    type: 'text',
    label: 'Brand URL',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 charactors allowed.',
    maxLength: 100,
    maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    pattern: /^(https?:\/\/)([a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)(\/.*)?$/,
    // labelLayout:'py-1',
    // tooltip: '<div> IO Name </div>',
    // spaceNotAllowed: true,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Goal Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
    // pattern: /^(?=.*?[A-Za-z]).{1,}$/
  },


  category: {
    key: 'category',
    label: 'Business Category',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'key',
    textKey: 'description',
  },


  subcategory: {
    key: 'subcategory',
    label: 'Business Sub-Category',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    labelLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'key',
    textKey: 'description',
  },




  totalBudget: {
    key: 'totalBudget',
    type: 'number',
    // label: 'Budget',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    max:999999999999, 
    upto4Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },


  // objective: {
  //   key: 'objective',
  //   type: 'text',
  //   label: 'Objective / Goal',
  //   placeholder: '',
  //   // Add other properties as needed for validation, messages, and configuration
  // },
  // goalValue: {
  //   key: 'goalValue',
  //   type: 'number',
  //   label: 'Goal Value',
  //   placeholder: '',
  //   // Add other properties as needed for validation, messages, and configuration
  // },
  // campaignStartDate: {
  //   key: 'campaignStartDate',
  //   type: 'date',
  //   label: 'Campaign Start Date',
  //   placeholder: '',
  //   // Add other properties as needed for validation, messages, and configuration
  // },
  // campaignEndDate: {
  //   key: 'campaignEndDate',
  //   type: 'date',
  //   label: 'Campaign End Date',
  //   placeholder: '',
  //   // Add other properties as needed for validation, messages, and configuration
  // },
};
